import { useContext } from "react";
import ToastContext from "@/shared/contexts/ToastContext";

export function useToast() {
  const context = useContext(ToastContext);
  if (context === undefined) {
    throw new Error("useToastContext must be used within a ToastProvider");
  }
  return context;
}
